/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {COLORS} from "@res/colors";


export const MessageSeparator = () => {
    return <div style={{
        height: 1,
        backgroundColor: COLORS.grays_2,
        border: 'none'
    }}/>;

}
